export default {
    'diagram3b3-2': {
        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
        'element_1_1': 'In the agricultural era, land was the source of wealth, so the landed aristocracy naturally controlled the direction of society',
        'element_1_2': 'Capitalists supplanted aristocrats not because of a shift in ideology but because of a shift in technology',
        'element_1_3': 'In the industrial era, the new technologies of steam and electricity shifted the source of wealth, bestowing strategic advantage on their capitalist owners',
        'element_1_4': 'In any era, the key decision makers will be those with a strategic economic advantage that affords them wealth',
        'element_1_5': 'Thus, capitalists supplanted aristocrats as the key decision makers in society',
      'hint-title': 'Hint',
      'resubmit-title': 'Resubmit'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b3/diagram2/i18n/en.js